import React from 'react';
import { Input } from 'antd';

const IntegerQtyInput = ({
  value,
  onChange,
  placeholder,
  style,
  disabled,
  ...rest
}) => {
  let str = '';
  if (value !== null && value !== undefined) {
    const n = Number(value);
    str = Number.isFinite(n) ? String(Math.floor(n)) : '';
  }

  return (
    <Input
      {...rest}
      inputMode="numeric"
      autoComplete="off"
      disabled={disabled}
      value={str}
      onChange={(e) => {
        const raw = e.target.value.trim();
        if (raw === '') {
          onChange(null);
          return;
        }

        if (/[.,]/.test(raw)) return;
        if (!/^\d+$/.test(raw)) return;
        const n = parseInt(raw, 10);
        if (!Number.isFinite(n)) {
          onChange(null);
          return;
        }
        onChange(n);
      }}
      placeholder={placeholder}
      style={style}
    />
  );
};

export default IntegerQtyInput;
